import * as React from "react";

import { Separator as SeparatorPrimitive } from "@base-ui/react/separator";
import { cn } from "@/shadcn/lib/utils";

// playerdex · registry v1 · shadcn@4.21.0

const Separator = React.forwardRef(function Separator(
  { className, orientation = "horizontal", ...props },
  ref
) {
  return (
    <SeparatorPrimitive
      data-slot="separator"
      orientation={orientation}
      className={cn(
        "bg-border shrink-0 data-horizontal:h-px data-horizontal:w-full data-vertical:w-px data-vertical:self-stretch",
        className
      )}
      ref={ref}
      {...props}
    />
  );
});

export { Separator };
